$(document).ready(function () {

    // Slide
    let owlHomeSlider = $('.carousel-slider').owlCarousel({
        items: 1,
        loop: true,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 7000
    });

    $('.btn-back-slider').on('click', function () {
        owlHomeSlider.trigger('prev.owl.carousel');
    });

    $('.btn-forward-slider').on('click', function () {
        owlHomeSlider.trigger('next.owl.carousel');
    });

});
